import {Box, Typography} from "@mui/material";
import PaymentIcon from "@mui/icons-material/Payments";
import ArrowIcon from "@mui/icons-material/ExpandMore";

export default (props) => (
  <Box
    display="flex"
    alignItems="center"
    gap="8px"
    fontSize="14px"
    color="rgba(237, 160, 68, 1)"
    {...props}
  >
    <PaymentIcon />
    <Typography lineHeight="20px" fontWeight={600} letterSpacing="0.25px">
      Invite your friends & get paid
    </Typography>
  </Box>
);